import styled, {css} from 'styled-components';

export const CollapseIndicatorDefaultBox = styled.div<{isOpen?: boolean}>`
    width: 5px;
    height: 5px;
    border: solid ${({theme}) => theme.colors.backgroundContrast};
    border-width: 0 2px 2px 0;
    padding: 3px;
    transform: rotate(45deg);
    transition: transform 0.2s ease-in-out;

    ${props => props.isOpen && css`
      transform: rotate(225deg);
    `}
`;